// src/services/openAIService.ts
import OpenAI from "openai";

const openai = new OpenAI({
  apiKey: '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',
  dangerouslyAllowBrowser: true,
});

interface ImproveJDPayload {
  jdContent: string;
  whatToImprove: string;
}

interface GenerateJobPayload {
  companyBackground: string;
  jdContent: string;
  location: string;
  deadline: string;
}

export const improveJD = async ({ jdContent, whatToImprove }: ImproveJDPayload) => {
  const response = await openai.chat.completions.create({
    model: "gpt-4o-mini",
    messages: [
      {
        role: "system",
        content: `You are a helpful assistant that improves job descriptions by refining their content and structure while maintaining clarity and professionalism. 
        - Preserve the existing formatting and headings.
        - Do not add bold text (**), special characters, or additional section titles unless they are already in the content.
        - Ensure the content remains structured, engaging, and grammatically correct.`,
      },
      {
        role: "user",
        content: `Improve by noting ${whatToImprove} the following job description while keeping the formatting unchanged:\n\n${jdContent}\n\nDo not introduce new headings like 'Key Responsibilities' or add any bold formatting if not originally present.`,
      },
    ],
  });
  return response.choices[0].message.content;
};

export const generateJobContent = async ({ companyBackground, jdContent, location, deadline }: GenerateJobPayload) => {
  const response = await openai.chat.completions.create({
    model: "gpt-4o-mini",
    messages: [
      {
        role: "system",
        content: `You are a helpful assistant that generates job-related content. 
        Output the response in valid JSON format only, with the following structure:
        {
          "linkedinPost": "Text for LinkedIn post",
          "screeningQuestions": ["Question 1", "Question 2", "Question 3", "Question 4"],
          "flyerContent": {
            "jobTitle": "Job Title",
            "jobDescription": "• Point 1.\\n• Point 2.\\n• Point 3.\\n• Point 4.\\n• Point 5.\\n• Point 6."
            "specifications": "• Spec 1.\\n• Spec 2.\\n• Spec 3.\\n• Spec 4."
          },
          "emailContent": "Thank-you email content"
        }`
      },
      {
        role: "user",
        content: `Company Background:\n${companyBackground}\n\n
        Job Description:\n${jdContent}\n\n
        Location:\n${location}\n\n
        Deadline:\n${deadline}\n\n
        Please generate the following content in plain text only (do not include Do not include any additional fancy logos, emojis, or tickers in any of the generated content.).\n
        Write a LinkedIn formatted engaging job post, 2-3 short paragraphs, highlight the key role details, include relevant hashtags, and include a call to action. Show the deadline of the job on the next line in the format like 'Deadline: ${deadline}'.\n
        Provide four relevant screening questions.\n
        Also provide formatted content for a flyer that will consist of:\n
        - Job title\n
        - 4-6 points of the Job description (each around 90 characters with spaces, formatted as bullet points)\n
        - 4 points of job specifications (each around 63 characters with spaces, formatted as bullet points)\n
        - 2 job requirements\n
        - 2 salary & benefits points\n
        And write a thank-you email content for applicants.\n
        Do not include any additional fancy logos, emojis, or tickers.`
      }
    ],
    response_format: { type: "json_object" }
  });
  return response.choices[0].message.content || "{}";
};

export default {
  improveJD,
  generateJobContent
};